import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Typography, Container } from '@mui/material';
import { LocalHospital as HospitalIcon } from '@mui/icons-material';

/**
 * Auth Layout
 * Minimal layout for authentication pages (Login, Register, etc.).
 *
 * @author Civilhealth Development Team
 */

const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #E8E8E8 0%, #F5F5F5 50%, #EBEBEB 100%)',
      }}
    >
      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
          px: 2,
        }}
      >
        <Outlet />
      </Box>

      {/* Footer */}
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="body2" sx={{ color: '#6B7280' }}>
          © {new Date().getFullYear()} Civilhealth Healthcare Response Management System
        </Typography>
        <Typography variant="caption" sx={{ color: '#9CA3AF', display: 'block', mt: 0.5 }}>
          A Government of India Initiative
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthLayout;